import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { PropTypes } from 'prop-types';
import { CtaButton } from '../AfterSalesCtas.styles';
import { SEND_BOOKING_CONFIRMATION } from '../../../../../store/mutations';
import BookingEmailSent from './Modal/BookingEmailSent';
import BookingEmailFailed from './Modal/BookingEmailFailed';
import BookingEmailLoading from './Modal/BookingEmailLoading';
import { isValidEmail } from 'utils/validators';
function SendBookingConfirmationCta({ label, bookingReference, customerEmail = '', disabled }) {
  const hasCustomerEmail = isValidEmail(customerEmail);
  const [sendConfirmationEmail, { loading, error }] = useMutation(SEND_BOOKING_CONFIRMATION);
  const [isOpen, setOpen] = useState(false);

  const onClick = () => {
    if (disabled) {
      return;
    }
    sendConfirmationEmail({
      variables: {
        bookingReference
      }
    });
    setOpen(true);
  };

  return (
    <>
      <CtaButton
        disabled={disabled || !hasCustomerEmail}
        label={label}
        onClick={onClick}
        showTip={!hasCustomerEmail}
        textIdTip="bookingDetails.noCustomerEmails"
      />
      {loading && <BookingEmailLoading isOpen={isOpen} onClose={() => setOpen(false)} />}
      {!loading &&
        (error ? (
          <BookingEmailFailed isOpen={isOpen} onClose={() => setOpen(false)} />
        ) : (
          <BookingEmailSent isOpen={isOpen} onClose={() => setOpen(false)} customerEmail={customerEmail} />
        ))}
    </>
  );
}

SendBookingConfirmationCta.propTypes = {
  label: PropTypes.node,
  bookingReference: PropTypes.string,
  customerEmail: PropTypes.string,
  disabled: PropTypes.bool
};

export default SendBookingConfirmationCta;
